import { FieldModel, AbpBaseConstant } from '@colibrium/abp-base';
import * as ɵngcc0 from '@angular/core';

const _c0 = ["inputControlVariable"];
export { AbpBaseConstant, ConversionHelper, DateConstant, DateHelper, DateModel, DatePartModel, FieldModel, FieldType, StringHelper } from '@colibrium/abp-base';
import { Injector, Optional, Inject, ChangeDetectorRef, ViewChild, Input, ViewChildren } from '@angular/core';
import { NgControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { AbpValidationDisplayConstant } from '@colibrium/abp-validation-display';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/value-accessor.base.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#region angular imports
//#endregion angular imports
//#region core imports
//#endregion core imports
//#region functional/model imports
//#endregion functional/model imports
class ValueAccessorBase {
    //#endregion model properties
    //#region constructor
    constructor() {
        this.innerValue = '';
        this.disabled = false;
        this.onChange = (/**
         * @return {?}
         */
        () => { });
        this.onTouched = (/**
         * @return {?}
         */
        () => { });
    }
    //#endregion constructor
    //#region get/set properties
    /**
     * @return {?}
     */
    get value() { return this.innerValue; }
    /**
     * @param {?} value
     * @return {?}
     */
    set value(value) {
        //When value changes, notify the custom form control by calling onChange and/or onTouched to update the custom control model value accordingly
        if (this.innerValue !== value) {
            this.innerValue = value;
            this.onChange(value);
            this.onTouched(value);
        }
    }
    //#endregion get/set properties
    //#region public functions
    //#region interface implementation
    /**
     * this method is called by the forms API to write to the view when programmatic changes from model to view are requested.
     * @param {?} val
     * @return {?}
     */
    writeValue(val) {
        if (val == undefined || val == null) {
            /**
             * reset condition. If value is null, consider the control as reset.
             * If null is assigned on purpose, then consider it as reset as well. We should not call onChange in this scenario.
             * Else control dirty and touched statuses does not get reset
             */
            this.innerValue = null;
        }
        else {
            this.value = val;
        }
    }
    /**
     * registers a callback function that is called when the control's value changes in the UI.
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this.onChange = fn;
    }
    /**
     * registers a callback function is called by the forms API on initialization to update the form model on blur.
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * function that is called by the forms API when the control status changes to or from 'DISABLED'
     * @param {?} isDisabled
     * @return {?}
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
}
if (false) {
    /** @type {?} */
    ValueAccessorBase.prototype.disabled;
    /** @type {?} */
    ValueAccessorBase.prototype.onChange;
    /** @type {?} */
    ValueAccessorBase.prototype.onTouched;
    /**
     * @type {?}
     * @private
     */
    ValueAccessorBase.prototype.innerValue;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/input-field.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class InputFieldModel extends FieldModel {
    //#endregion event hander properties
    //#region read only properties
    //#endregion read only properties
    //#region constructor
    constructor() {
        super();
        this.isDisabled = false;
    }
}
if (false) {
    /** @type {?} */
    InputFieldModel.prototype.isRequired;
    /** @type {?} */
    InputFieldModel.prototype.isDisabled;
    /** @type {?} */
    InputFieldModel.prototype.fieldValue;
    /** @type {?} */
    InputFieldModel.prototype.validationMap;
    /** @type {?} */
    InputFieldModel.prototype.blurEventHandler;
    /** @type {?} */
    InputFieldModel.prototype.changeEventHandler;
    /** @type {?} */
    InputFieldModel.prototype.clickEventHandler;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/abp-text-field.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class AbpTextFieldModel extends InputFieldModel {
    //#endregion model properties
    //#region event handler properties
    //#endregion event hander properties
    //#region read only properties
    //#endregion read only properties
    //#region constructor
    constructor() {
        super();
    }
}
if (false) {
    /** @type {?} */
    AbpTextFieldModel.prototype.maxLength;
    /** @type {?} */
    AbpTextFieldModel.prototype.minLength;
    /** @type {?} */
    AbpTextFieldModel.prototype.pattern;
    /** @type {?} */
    AbpTextFieldModel.prototype.placeHolder;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/abp-datepicker-field.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class AbpDatepickerFieldModel extends InputFieldModel {
    //#endregion model properties
    //#region event handler properties
    //#endregion event hander properties
    //#region read only properties
    //#endregion read only properties
    //#region constructor
    constructor() {
        super();
    }
}
if (false) {
    /** @type {?} */
    AbpDatepickerFieldModel.prototype.placeHolder;
    /** @type {?} */
    AbpDatepickerFieldModel.prototype.dateFormat;
    /** @type {?} */
    AbpDatepickerFieldModel.prototype.restrictPast;
    /** @type {?} */
    AbpDatepickerFieldModel.prototype.restrictFuture;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/abp-label-field.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class AbpLabelFieldModel extends FieldModel {
    //#endregion model properties
    //#region event handler properties
    //#endregion event hander properties
    //#region read only properties
    //#endregion read only properties
    //#region constructor
    constructor() {
        super();
        //#region model properties
        this.isRequired = true;
    }
}
if (false) {
    /** @type {?} */
    AbpLabelFieldModel.prototype.isRequired;
    /** @type {?} */
    AbpLabelFieldModel.prototype.fieldValue;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/control.base.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
/**
 * @template T
 */
class ControlBase extends ValueAccessorBase {
    //#endregion model properties
    //#region constructor
    /**
     * @param {?} injector
     * @param {?} validationConfig
     * @param {?} changeDetector
     */
    constructor(injector, validationConfig, changeDetector) {
        super();
        this.injector = injector;
        this.validationConfig = validationConfig;
        this.changeDetector = changeDetector;
        //#endregion input properties
        //#region model properties
        this.control = new BehaviorSubject(null);
        this.isDynamic = false;
        this.inputControlCss = '';
        this.validationConfig = this.getValidationConfigDefaults(this.validationConfig);
    }
    //#endregion constructor
    //#region public functions
    //#region life cycle event methods
    /**
     * on initialization
     * @protected
     * @param {?=} controlClass
     * @return {?}
     */
    onInitialization(controlClass = AbpBaseConstant.cssClass.abp_input_control) {
        this.setDisplayLabelField();
        this.setInputControlClass(controlClass);
        this.setValueBase(this.getInitialValue());
    }
    /**
     * on ng on changes
     * @protected
     * @param {?} simpleChanges
     * @param {?=} controlClass
     * @return {?}
     */
    onNgInputChanges(simpleChanges, controlClass = AbpBaseConstant.cssClass.abp_input_control) {
        if (simpleChanges.field && simpleChanges.field.previousValue != simpleChanges.field.currentValue) {
            this.onInitialization(controlClass);
        }
        if (simpleChanges.isFormSubmitted && simpleChanges.isFormSubmitted.previousValue != simpleChanges.isFormSubmitted.currentValue) {
            if (!this.isFormSubmitted) {
                this.clearValidationClasses();
            }
        }
    }
    /**
     * on view initialization
     * @protected
     * @return {?}
     */
    onViewInitialization() {
        this.setControl();
    }
    //#endregion life cycle event methods
    /**
     * runs change detection on demand
     * @return {?}
     */
    runChangeDetection() {
        this.onInitialization(this.inputControlCss);
        //reset css classes before running change detection accordingly in order to refresh UI
        if (!this.isFormSubmitted) {
            this.clearValidationClasses();
        }
        this.changeDetector.detectChanges();
    }
    /**
     * on input change
     * @param {?} val
     * @return {?}
     */
    onInputChange(val) {
        this.setValueBase(val);
        if (this.field instanceof InputFieldModel && this.field.changeEventHandler) {
            this.field.changeEventHandler(val);
        }
    }
    /**
     * on input blur
     * @param {?} val
     * @return {?}
     */
    onInputBlur(val) {
        this.setValueBase(val);
        if (this.field instanceof AbpTextFieldModel || this.field instanceof AbpDatepickerFieldModel) {
            if (this.field.blurEventHandler) {
                this.field.blurEventHandler(val);
            }
        }
    }
    /**
     * sets base value for all events
     * @param {?} val
     * @return {?}
     */
    setValueBase(val) {
        if (val == undefined) {
            val = null;
        }
        this.value = val;
        this.field.fieldValue = this.value;
        if (this.isDynamic && this.control) {
            this.control.value.setValue(this.value);
        }
    }
    /**
     * sets base control csss class
     * @param {?} controlClass
     * @return {?}
     */
    setInputControlClass(controlClass) {
        this.inputControlCss = this.field.cssClass ? this.field.cssClass : controlClass;
    }
    /**
     * sets class for control based on validity
     * @param {?} isValid
     * @return {?}
     */
    setClassForControlValidity(isValid) {
        if (this.inputControl) {
            this.clearValidationClasses();
            if (isValid == true) {
                if (this.validationConfig.successControlClass) {
                    this.inputControl.nativeElement.classList.add(this.validationConfig.successControlClass);
                }
            }
            else if (isValid == false) {
                if (this.validationConfig.errorControlClass) {
                    this.inputControl.nativeElement.classList.add(this.validationConfig.errorControlClass);
                }
            }
        }
    }
    /**
     * sets display label field
     * @return {?}
     */
    setDisplayLabelField() {
        this.displayLabelField = new AbpLabelFieldModel();
        if (this.field) {
            this.displayLabelField.fieldCode = this.field.fieldCode;
            this.displayLabelField.displayLabelText = this.field.displayLabelText;
            this.displayLabelField.isVisible = this.field.isVisible;
            this.displayLabelField.isRequired = this.field.isRequired;
            this.displayLabelField.displayLabelCss = this.field.displayLabelCss;
        }
    }
    //#endregion public functions
    //#region private functions
    /**
     * sets control value
     * @private
     * @return {?}
     */
    setControl() {
        if (!this.isDynamic) {
            this.control.next((/** @type {?} */ (this.injector.get(NgControl).control)));
            //this.control.unsubscribe();
        }
    }
    /**
     * clears classes for validations
     * @private
     * @return {?}
     */
    clearValidationClasses() {
        if (this.inputControl && this.inputControl.nativeElement && this.inputControl.nativeElement.classList) {
            if (this.inputControl.nativeElement.classList.contains(this.validationConfig.successControlClass)) {
                this.inputControl.nativeElement.classList.remove(this.validationConfig.successControlClass);
            }
            if (this.inputControl.nativeElement.classList.contains(this.validationConfig.errorControlClass)) {
                this.inputControl.nativeElement.classList.remove(this.validationConfig.errorControlClass);
            }
        }
    }
    /**
     * gets default values for configs
     * @private
     * @param {?} injectionModel
     * @return {?}
     */
    getValidationConfigDefaults(injectionModel) {
        if (!injectionModel) {
            injectionModel = {
                errorControlClass: AbpBaseConstant.cssClass.abp_input_control_error,
                errorTextClass: AbpBaseConstant.cssClass.abp_error_text,
                showErrorOnSubmitOnly: false,
                successControlClass: AbpBaseConstant.cssClass.abp_input_control_valid
            };
        }
        return injectionModel;
    }
    /**
     * gets initial control value from FormControl if defined. Else gets field value
     * @private
     * @return {?}
     */
    getInitialValue() {
        if (this.control && this.control.value && this.control.value.value) {
            return this.control.value.value;
        }
        else {
            return this.field.fieldValue;
        }
    }
}
ControlBase.ɵfac = function ControlBase_Factory(t) { return new (t || ControlBase)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector, 8), ɵngcc0.ɵɵdirectiveInject(AbpValidationDisplayConstant.validationDisplayConfigInjectKey), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
ControlBase.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ControlBase, viewQuery: function ControlBase_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputControl = _t.first);
    } }, inputs: { field: "field", isFormSubmitted: "isFormSubmitted", id: "id" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
/** @nocollapse */
ControlBase.ctorParameters = () => [
    { type: Injector, decorators: [{ type: Optional }] },
    { type: undefined, decorators: [{ type: Inject, args: [AbpValidationDisplayConstant.validationDisplayConfigInjectKey,] }] },
    { type: ChangeDetectorRef }
];
ControlBase.propDecorators = {
    inputControl: [{ type: ViewChild, args: ['inputControlVariable', { static: false },] }],
    field: [{ type: Input }],
    isFormSubmitted: [{ type: Input }],
    id: [{ type: Input }]
};

if (false) {
    /**
     * @type {?}
     * @private
     */
    ControlBase.prototype.inputControl;
    /** @type {?} */
    ControlBase.prototype.field;
    /** @type {?} */
    ControlBase.prototype.isFormSubmitted;
    /** @type {?} */
    ControlBase.prototype.id;
    /** @type {?} */
    ControlBase.prototype.control;
    /** @type {?} */
    ControlBase.prototype.isDynamic;
    /** @type {?} */
    ControlBase.prototype.inputControlCss;
    /** @type {?} */
    ControlBase.prototype.displayLabelField;
    /**
     * @type {?}
     * @protected
     */
    ControlBase.prototype.injector;
    /**
     * @type {?}
     * @protected
     */
    ControlBase.prototype.validationConfig;
    /**
     * @type {?}
     * @protected
     */
    ControlBase.prototype.changeDetector;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/select-list-control.base.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
/**
 * @template T
 */
class SelectListControlBase extends ControlBase {
    //#endregion ViewChild
    //#region input properties
    //#endregion input properties
    //#region model properties
    //#endregion model properties
    //#region constructor
    /**
     * @param {?} injectorInstance
     * @param {?} validationConfig
     * @param {?} detectorRef
     */
    constructor(injectorInstance, validationConfig, detectorRef) {
        super(injectorInstance, validationConfig, detectorRef);
    }
    //#endregion constructor
    //#region public functions
    //#region life cycle event methods
    /**
     * on initialization - Overriding base method
     * @protected
     * @param {?=} controlClass
     * @return {?}
     */
    onInitialization(controlClass = AbpBaseConstant.cssClass.abp_input_control) {
        super.onInitialization(controlClass);
        this.setOptions();
    }
    /**
     * on ng on changes - Overriding base method
     * @protected
     * @param {?} simpleChanges
     * @param {?=} controlClass
     * @return {?}
     */
    onNgInputChanges(simpleChanges, controlClass = AbpBaseConstant.cssClass.abp_input_control) {
        super.onNgInputChanges(simpleChanges, controlClass);
        if (simpleChanges.field && simpleChanges.field.previousValue != simpleChanges.field.currentValue) {
            this.setOptions();
        }
    }
    //#endregion life cycle event methods
    /**
     * sets list control options
     * @return {?}
     */
    setOptions() {
        if (this.field && this.field.options && this.field.options.length > 0) {
            this.field.options.forEach((/**
             * @param {?} map
             * @return {?}
             */
            (map) => {
                //If field value is present, set isSelected value. Else consider user input
                if (this.field.fieldValue) {
                    if ((Array.isArray(this.field.fieldValue) && this.field.fieldValue.includes(map.value)) ||
                        this.field.fieldValue == map.value) {
                        map.isSelected = true;
                    }
                    else {
                        map.isSelected = false;
                    }
                }
                else {
                    //set field value based on isSelected status
                    if (map.isSelected) {
                        this.setValueBase(map.value);
                    }
                }
            }));
        }
    }
    /**
     * sets isSelected status for options
     * @param {?} val
     * @return {?}
     */
    setOptionSelectionState(val) {
        this.field.options.forEach((/**
         * @param {?} item
         * @return {?}
         */
        (item) => {
            item.isSelected = (val == item.value);
        }));
    }
    /**
     * sets class for control based on validity
     * @param {?} isValid
     * @return {?}
     */
    setClassForControlValidity(isValid) {
        if (this.inputControlList && this.inputControlList.length > 0) {
            this.clearValidations();
            if (this.isFormSubmitted) {
                this.inputControlList.forEach((/**
                 * @param {?} map
                 * @return {?}
                 */
                (map) => {
                    if (isValid == true) {
                        if (this.validationConfig.successControlClass) {
                            map.nativeElement.classList.add(this.validationConfig.successControlClass);
                        }
                    }
                    else if (isValid == false) {
                        if (this.validationConfig.errorControlClass) {
                            map.nativeElement.classList.add(this.validationConfig.errorControlClass);
                        }
                    }
                }));
            }
        }
    }
    //#endregion public functions
    //#region private functions
    /**
     * clears classes for validations
     * @private
     * @return {?}
     */
    clearValidations() {
        if (this.inputControlList && this.inputControlList.length > 0) {
            this.inputControlList.forEach((/**
             * @param {?} map
             * @return {?}
             */
            (map) => {
                if (map.nativeElement && map.nativeElement.classList) {
                    if (map.nativeElement.classList.contains(this.validationConfig.successControlClass)) {
                        map.nativeElement.classList.remove(this.validationConfig.successControlClass);
                    }
                    if (map.nativeElement.classList.contains(this.validationConfig.errorControlClass)) {
                        map.nativeElement.classList.remove(this.validationConfig.errorControlClass);
                    }
                }
            }));
        }
    }
}
SelectListControlBase.ɵfac = function SelectListControlBase_Factory(t) { return new (t || SelectListControlBase)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector, 8), ɵngcc0.ɵɵdirectiveInject(AbpValidationDisplayConstant.validationDisplayConfigInjectKey), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
SelectListControlBase.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: SelectListControlBase, viewQuery: function SelectListControlBase_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputControlList = _t);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
/** @nocollapse */
SelectListControlBase.ctorParameters = () => [
    { type: Injector, decorators: [{ type: Optional }] },
    { type: undefined, decorators: [{ type: Inject, args: [AbpValidationDisplayConstant.validationDisplayConfigInjectKey,] }] },
    { type: ChangeDetectorRef }
];
SelectListControlBase.propDecorators = {
    inputControlList: [{ type: ViewChildren, args: ['inputControlVariable',] }]
};

if (false) {
    /**
     * @type {?}
     * @private
     */
    SelectListControlBase.prototype.inputControlList;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/abp-check-field.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class AbpCheckFieldModel extends InputFieldModel {
    //#endregion model properties
    //#region event handler properties
    //#endregion event hander properties
    //#region read only properties
    //#endregion read only properties
    //#region constructor
    constructor() {
        super();
        this.isLableOnLeft = false;
    }
}
if (false) {
    /** @type {?} */
    AbpCheckFieldModel.prototype.checked;
    /** @type {?} */
    AbpCheckFieldModel.prototype.isLableOnLeft;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/select-list-field.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class SelectListFieldModel extends InputFieldModel {
    //#endregion model properties
    //#region event handler properties
    //#endregion event hander properties
    //#region read only properties
    //#endregion read only properties
    //#region constructor
    constructor() {
        super();
    }
}
if (false) {
    /** @type {?} */
    SelectListFieldModel.prototype.options;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/abp-check-list-field.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class AbpCheckListFieldModel extends SelectListFieldModel {
    //#endregion model properties
    //#region event handler properties
    //#endregion event hander properties
    //#region read only properties
    //#endregion read only properties
    //#region constructor
    constructor() {
        super();
        this.isLableOnLeft = false;
    }
}
if (false) {
    /** @type {?} */
    AbpCheckListFieldModel.prototype.options;
    /** @type {?} */
    AbpCheckListFieldModel.prototype.isLableOnLeft;
    /** @type {?} */
    AbpCheckListFieldModel.prototype.noneOptionDisplayText;
    /** @type {?} */
    AbpCheckListFieldModel.prototype.allOptionDisplayText;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/abp-drop-down-field.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class AbpDropDownFieldModel extends SelectListFieldModel {
    //#endregion model properties
    //#region event handler properties
    //#endregion event hander properties
    //#region read only properties
    //#endregion read only properties
    //#region constructor
    constructor() {
        super();
    }
}
if (false) {
    /** @type {?} */
    AbpDropDownFieldModel.prototype.placeHolder;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/abp-radio-button-field.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class AbpRadioButtonFieldModel extends SelectListFieldModel {
    //#region model properties
    //#endregion model properties
    //#region event handler properties
    //#endregion event hander properties
    //#region read only properties
    //#endregion read only properties
    //#region constructor
    constructor() {
        super();
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/abp-switch-field.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class AbpSwitchFieldModel extends InputFieldModel {
    //#endregion model properties
    //#region event handler properties
    //#endregion event hander properties
    //#region read only properties
    //#endregion read only properties
    //#region constructor
    constructor() {
        super();
    }
}
if (false) {
    /** @type {?} */
    AbpSwitchFieldModel.prototype.onSwitchDisplayText;
    /** @type {?} */
    AbpSwitchFieldModel.prototype.offSwitchDisplayText;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/select-list-item.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#region angular imports
//#endregion angular imports
//#region core imports
//#endregion core imports
//#region functional/model imports
//#endregion functional/model imports
class SelectListItem {
}
if (false) {
    /** @type {?} */
    SelectListItem.prototype.value;
    /** @type {?} */
    SelectListItem.prototype.displayText;
    /** @type {?} */
    SelectListItem.prototype.isSelected;
    /** @type {?} */
    SelectListItem.prototype.isDisabled;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: colibrium-abp-form-control-base.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AbpCheckFieldModel, AbpCheckListFieldModel, AbpDatepickerFieldModel, AbpDropDownFieldModel, AbpLabelFieldModel, AbpRadioButtonFieldModel, AbpSwitchFieldModel, AbpTextFieldModel, ControlBase, InputFieldModel, SelectListControlBase, SelectListFieldModel, SelectListItem, ValueAccessorBase };

//# sourceMappingURL=colibrium-abp-form-control-base.js.map